import { Box } from '@mui/material';
import { SWRConfig } from 'swr';
import type { SideComponentProps } from '@/common/types/app';
import { ReportsDashboard } from '@/components/Reports/ReportsDashboard/ReportsDashboard';

const ReportsPage: SideComponentProps = () => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        flex: 1,
        minHeight: 0,
        height: '100%',
      }}
    >
      <SWRConfig
        value={{
          revalidateOnFocus: false,
          errorRetryCount: 2,
        }}
      >
        <ReportsDashboard />
      </SWRConfig>
    </Box>
  );
};

ReportsPage.appShellProps = {
  hideInteractionSidebar: true,
};

ReportsPage.disableInteractionValidation = true;

export default ReportsPage;
